<template>
<div>
    <hr class="spacer half">
    <h1 class="big">
        Commute Sum
    </h1>
    
    <p class="capitalize">
        {{ $t('intro.pitch') }}
    </p>
    
    <div class="row"  v-responsive.class>
        <div class="col"  v-scroll-to="'#commute_1'" >
        
         <div class="badge">
            <img class="badge" src="icons/calculator_100_white.png"> 
            
            </div>
        
            <h3>{{ $t('intro.vignette.calculate') }} </h3>
            
            <ul class="one">
            <li>{{ $t('intro.vignette.calculate.1') }} </li>
            <li v-responsive.lg.xl.md >{{ $t('intro.vignette.calculate.2') }} </li>
            </ul>
            
        </div>
        <div class="col"  v-scroll-to="'#commute_1'" >
        
             <div class="badge">
                <img src="icons/public_30_white.png">
                <img src="icons/other_30_white.png">
                <img src="icons/bicycle_30_white.png">
                <img src="icons/car_30_white.png">
            </div>
        
            <h3>{{ $t('intro.vignette.compare') }}</h3>
            <ul class="two">
            <li>{{ $t('intro.vignette.compare.1') }} </li>
            <li>{{ $t('intro.vignette.compare.2') }} </li>
            </ul>
            
        </div>
        <div class="col"  v-scroll-to="'#commute_1'" >
            <div class="badge">
            <img src="icons/huh_30_white.png">
            </div>
            
            <h3>{{ $t('intro.vignette.save') }}</h3>
            
            <ul class="three">
            <li>{{ $t('intro.vignette.save.1') }}  </li>
            <li>{{ $t('intro.vignette.save.2') }}  </li>
            </ul>
            
        </div>
    
    </div>
    <h3 v-scroll-to="'#commute_1'" >{{ $t('intro.scroll-to-start') }}  </h3>
    <img v-scroll-to="'#commute_1'" src="icons/continue_30.png">
        <hr class="spacer half">

    <p>
        <img src="icons/clock_18.png" class="floatimg" /> {{ $t('intro.timing') }}
    </p>
        
</div>
</template>

<script>

import Social from './Social.vue'

export default {
    
    components: {
         Social
    },
    data: function(){
        return {
        
        }
    },
    props: {
        commutes : Array,
        energy_costs: Object,
    }
}

</script>

<style scoped>

div.row div.col:hover {
    background-color: #aaa;
}

.col * {
    cursor: pointer;
}

.floatimg {

    float: left;
    margin-top: 1px;
    margin-right: 5px;

}

div.row div.col{
    background-color: #eee;
    border-radius: 1em;
    text-align: left;
    padding: 1em;
    clear: both;
    
    
    background: -moz-linear-gradient(-45deg, rgba(222,239,255,1) 0%, rgba(152,190,222,.81) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(-45deg, rgba(222,239,255,1) 0%,rgba(152,190,222,.81) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(-45deg, rgba(222,239,255,1) 0%,rgba(152,190,222,.8) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

    
}
div.row div.col img.badge {
    height: 2em;
}
div.badge {
    text-align: center;
    height: 2em;
    color: #fff;
    font-weight: 900;
    
}


.bs4-xs *  .badge, .bs4-sm *  .badge {
    float: right;
}


div.badge > img{
    margin: 0 3px;
}

div.row div.col ul {
    padding: 0;
}

div.row div.col ul li{
    margin: .9em 0;
    padding-left:10px;
    font-size: 10pt;
}

div.row div.col ul.one li{
    border-left: 3px solid #ff0081;
}
div.row div.col ul.two li{
    border-left: 3px solid rgba(38,85,139,1);
}
div.row div.col ul.three li{
    border-left: 3px solid rgb(38, 139, 96);
}
</style>